import { render, staticRenderFns } from "./GalleryManager.vue?vue&type=template&id=7d435725&scoped=true&"
import script from "./GalleryManager.vue?vue&type=script&lang=ts&"
export * from "./GalleryManager.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryManager.vue?vue&type=style&index=0&id=7d435725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d435725",
  null
  
)

export default component.exports